export default () => {
    return !Settings.device.isIPad;
};
